import { useTranslations } from 'next-intl'

import { Spinner } from '@/shared/ui'

export const AvailableWeekCalendarFallback = () => {
  const t = useTranslations('date_selection')

  return (
    <div className="flex w-100 grow items-center justify-center p-6">
      <p className="typo-body1 text-center font-medium whitespace-break-spaces text-gray-400">
        {t('error.fallback')}
      </p>
    </div>
  )
}

export const ScheduleCalendarFallback = () => {
  const t = useTranslations('date_selection')

  return (
    <div className="flex w-100 grow items-center justify-center border-r border-gray-100 p-6">
      <p className="typo-body1 text-center font-medium whitespace-break-spaces text-gray-400">
        {t('error.fallback')}
      </p>
    </div>
  )
}

export const CalendarLoadingFallback = () => {
  return (
    <div className="relative flex w-100 grow items-center justify-center">
      <Spinner />
    </div>
  )
}

export const CalendarDialogErrorFallback = () => {
  const t = useTranslations('date_selection')

  return (
    <div className="mb-6 flex w-200 grow items-center justify-center">
      <p className="typo-body1 text-center font-medium whitespace-break-spaces text-gray-400">
        {t('error.fallback')}
      </p>
    </div>
  )
}

export const CalendarDialogLoadingFallback = () => {
  return (
    <div className="relative flex w-200 items-center justify-center">
      <Spinner />
    </div>
  )
}
